import { IResponse, IResponseContent } from '../stores/responsesStore'
import { encodeSlash } from '../utils/api'

import axiosAuth from './axiosAuth'

export const getResponses = (controller: AbortController, search: string) =>
    axiosAuth.get<IResponse[]>(`/nlg${search ? `?search=${search}` : ''}`, {
        signal: controller.signal,
    })

export const deleteResponse = (responseId: string) =>
    axiosAuth.delete(`/nlg/${encodeSlash(responseId)}`)

export const patchResponse = (oldResponseId: string, newResponseId: string) =>
    axiosAuth.patch(`/nlg/${encodeSlash(oldResponseId)}`, newResponseId)

export const getResponseContent = (
    controller: AbortController,
    responseId: string
) =>
    axiosAuth.get<IResponseContent[]>(`/nlg/${encodeSlash(responseId)}`, {
        signal: controller.signal,
    })

export const putResponseContent = (
    responseId: string,
    responseContent: IResponseContent
) =>
    axiosAuth.put<IResponseContent>(
        `/nlg/${encodeSlash(responseId)}`,
        responseContent
    )

export const postResponseContent = (
    responseId: string,
    responseContent: IResponseContent
) =>
    axiosAuth.post<IResponseContent>(
        `/nlg/${encodeSlash(responseId)}`,
        responseContent
    )

export const deleteResponseContent = (responseContentId: string) =>
    axiosAuth.delete(`/nlg/template/${responseContentId}`)
